import {EventSettingsModel} from "./EventSettingsModel";

export class EventModel {
	constructor() {
		this.eventId = null;
		this.unitId = null;

		this.settings = new EventSettingsModel();

		this.zones = [];
		this.stadiumSvg = null;

		/* переменные для работы с сектором */
		this.currentViewId = null;
	}

	setEventId(eventId) {
		if (!Number.isInteger(parseInt(eventId)))
			throw new Error("Не удалось получить корректный eventId!");

		return (this.eventId = parseInt(eventId));
	}

	getEventId() {
		return this.eventId;
	}

	removeZeroPriceZones(zones) {
		const filteredZones = zones.filter(zone => zone.price !== 0);

		/* Если наряду с ненулевыми ценами присутствуют нулевые */
		if (filteredZones.length > 0) return filteredZones;

		/* Если все нулевые */
		return zones;
	}
}
